import { useEffect, useState } from 'react';
import { sortBy } from 'lodash-es';
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');

const EXPLORER_API = 'https://explorer.mtt.network/api/v2';
import dayjs from 'dayjs';
interface Item {
  base_fee: number;
  fiat_price: number | null;
  price: number;
  priority_fee: number;
  priority_fee_wei: string;
  time: number;
  wei: string;
}
interface StatsStruct {
  average_block_time: number;
  coin_image: string;
  coin_price: number;
  coin_price_change_percentage: number;
  gas_price_updated_at: string;
  gas_prices: {
    average: Item;
    fast: Item;
    slow: Item;
  };
  gas_prices_update_in: number;
  gas_used_today: number;
  market_cap: string;
  network_utilization_percentage: number;
  static_gas_price: number;
  total_addresses: number;
  total_blocks: number;
  total_gas_used: number;
  total_transactions: number;
  transactions_today: number;
  tvl: number;
}

export default function useExplorerStats() {
  const [stats, setStats] = useState<StatsStruct | null>(null);

  useEffect(() => {
    if (!EXPLORER_API) return;
    fetch(`${EXPLORER_API}/stats`, {
      body: null,
      method: 'GET',
      mode: 'cors',
      headers: {
        'updated-gas-oracle': 'true',
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setStats(res);
      })
      .catch((err) => {
        console.error('fetch err', err);
      });

    let fetchInterval: NodeJS.Timeout | null = null;
    if (!fetchInterval) {
      fetchInterval = setInterval(() => {
        fetch(`${EXPLORER_API}/stats`, {
          body: null,
          method: 'GET',
          mode: 'cors',
          headers: {
            'updated-gas-oracle': 'true',
          },
        })
          .then((res) => res.json())
          .then((res) => {
            setStats(res);
          })
          .catch((err) => {
            console.error('fetch err', err);
          });
      }, 3000);
    }

    return () => {
      if (fetchInterval) {
        clearInterval(fetchInterval);
      }
    };
  }, []);

  return { stats };
}

export interface ChartTransactionItem {
  date: string;
  transaction_count: number | null;
}
export interface ChartTransactionResponse {
  chart_data: Array<ChartTransactionItem>;
}
export function useStatsCharts() {
  const [data, setData] = useState<Array<ChartTransactionItem> | null>(null);

  useEffect(() => {
    if (!EXPLORER_API) return;
    fetch(`${EXPLORER_API}/stats/charts/transactions`, {
      body: null,
      method: 'GET',
      mode: 'cors',
    })
      .then((res) => res.json())
      .then((res) => {
        const data = sortBy(res?.chart_data, 'date').map((item) => {
          return { ...item, date: dayjs(item.date).format('DD MMM YYYY') };
        });
        setData(data);
      })
      .catch((err) => {
        console.error('fetch err', err);
      });
  }, []);

  return { data };
}

dayjs.extend(utc);
dayjs.extend(timezone);

export const useNodeCountDown = () => {
  const targetDate = dayjs('2024-12-31T20:00:00').tz('Asia/Shanghai');
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = dayjs();
      const diff = targetDate.diff(now); // 计算剩余时间（毫秒）

      if (diff <= 0) {
        clearInterval(interval);
        setIsFinished(true);
      } else {
        const remainingDays = Math.floor(diff / (1000 * 60 * 60 * 24));
        const remainingHours = Math.floor(
          (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const remainingMinutes = Math.floor(
          (diff % (1000 * 60 * 60)) / (1000 * 60)
        );
        const remainingSeconds = Math.floor((diff % (1000 * 60)) / 1000);

        setDays(remainingDays);
        setHours(remainingHours);
        setMinutes(remainingMinutes);
        setSeconds(remainingSeconds);
      }
    }, 1000); // 每秒更新一次

    return () => clearInterval(interval); // 清理定时器
  }, [targetDate]);

  return {
    days,
    hours,
    minutes,
    seconds,
    isFinished,
  };
};
